import { useMemo } from 'react';
import { useSelector, shallowEqual } from 'react-redux';

import { selectPreviousPath } from 'state/journey-routes/journey-routes-slice';

export const usePageData = () => {
  const previousPath = useSelector(selectPreviousPath, shallowEqual);

  const { href, origin, hostname, pathname } = window.location;
  const previousRouteURL = `${origin}${previousPath}`;

  return useMemo(
    () => ({
      pageURL: href,
      page_domain: hostname,
      namespace: 'Energy Shop',
      referringURL: previousRouteURL,
      pageName: pathname,
      page_path: pathname
    }),
    [href, pathname, hostname, previousRouteURL]
  );
};
